import { RouteLink } from "types/route-link"
import dashboardUserRouteLinks from "../routeLinks/dashboardUserRouteLinks"
import { useMatch, useNavigate } from "react-router-dom"
import WidgetSet from "components/sidebar/components/widgetSet/WidgetSet";
import { useAppSelector } from "app/hooks";
import { selectIsNavbar, selectIsWidgetsOpen } from "selectors/layoutSelectors";
import { selectActiveWidgetInstanceId } from "selectors/widgetDashboardSelectors";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useGetLayersByRoleAndClient from "queryHooks/layerQueryHooks/useGetLayersByRoleAndClient";

type Props = {
    createLinks: (routes: Array<RouteLink>) => JSX.Element[];
    toggleNavbar: (isCollapse: boolean) => void;
}

const EndUserRoutes = (props: Props) => {
    const { createLinks, toggleNavbar } = props
    const match = useMatch("/widget-dashboard/*")
    const isWidgetDbActive = match?.pathnameBase === "/widget-dashboard"
    const isOpen = useAppSelector(selectIsWidgetsOpen);
    const navigate = useNavigate()
    const activeWidgetInstanceId = useAppSelector(selectActiveWidgetInstanceId)
    const isNavbar = useAppSelector(selectIsNavbar);
    const roleId = localStorage.getItem("role_id");
    const { data = [] } = useGetLayersByRoleAndClient({ roleId: roleId as string })

    // const handleWidgetsToggle = (isCollapse: boolean) => {
    //     toggleNavbar(isCollapse)
    //     navigate(`/widget-dashboard/${activeWidgetInstanceId}`)
    // }

    return (
        <>
            {data.length > 0 && createLinks(dashboardUserRouteLinks)}
            <li className="nav-item my-1">
                <div className={`${isWidgetDbActive ? "active link-opacity-10" : ""}`}>
                    {/* <span
                        onClick={() => handleWidgetsToggle(!isOpen)}
                        className="itemList"
                        style={{ flexDirection: isNavbar ? "row" : "column" }}
                    >
                        <FontAwesomeIcon icon={faPuzzlePiece} />
                        <p className="me-2">{"Widgets"}</p>
                        <FontAwesomeIcon
                            icon={isOpen ? faChevronUp : faChevronDown}
                            size="sm"
                            className="caret me-2"
                        />
                    </span> */}
                    <WidgetSet />
                </div>
            </li>
        </>
    )
}

export default EndUserRoutes